export var mainMappingKey = 'main-mapping';
export var mainMappingVariable = "{{" + mainMappingKey + "}}";
//# sourceMappingURL=main-mapping-pattern.js.map